export const locales = {
    'en-us': {
        accordion_expand: 'Expand All',
        accordion_collapse: 'Collapse All',
    },
    'es-us': {
        accordion_expand: 'Expandir Todo',
        accordion_collapse: 'Desplegar Todo',
    },
};
//# sourceMappingURL=locales.js.map